export default function StepHeader({ title, description }) {
  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold text-slate-900 mb-2">{title}</h2>
      <p className="text-slate-600">{description}</p>
    </div>
  );
}
